import {useSelector} from 'react-redux'

import {
  ORDER_SORT_OPTIONS,
  BATCH_SORT_OPTIONS,
} from '../../../common/constants/Orders.js'
import Sort from '../../../common/components/List/Sort.js'
import {orderListQuerySelector} from '../orderListSelectors.js'
import {setSort} from '../orderListActions.js'

export default function OrderSort() {
  const {sort, batch_reference_id} = useSelector(orderListQuerySelector)

  let options = ORDER_SORT_OPTIONS

  if (batch_reference_id[0]) {
    options = [...options, ...BATCH_SORT_OPTIONS]
  }

  return (
    <Sort items={options} value={sort} onChange={(value) => setSort(value)} />
  )
}
